import { EMonitorNotificationProvider } from '~/src/dash/api/monitors/monitors_models';
import { IMonitorNotificationProviderBaseClass } from '~/src/dash/components/monitor/monitor_notifications/notifier';
import { MonitorNotifierEmail } from '~/src/dash/components/monitor/monitor_notifications/notifier_email/notifier_email';
import { MonitorNotifierOpsgenie } from '~/src/dash/components/monitor/monitor_notifications/notifier_opsgenie/notifier_opsgenie';
import { MonitorNotifierSlack } from '~/src/dash/components/monitor/monitor_notifications/notifier_slack/notifier_slack';
import { MonitorNotifierURL } from '~/src/dash/components/monitor/monitor_notifications/notifier_url/notifier_url';

export function GetMonitorNotificationProviderClass(
  provider: EMonitorNotificationProvider,
): IMonitorNotificationProviderBaseClass | undefined {
  switch (provider) {
    case EMonitorNotificationProvider.MonitorNotificationProvider_URL:
      return new MonitorNotifierURL();
    case EMonitorNotificationProvider.MonitorNotificationProvider_EMAIL:
      return new MonitorNotifierEmail();
    case EMonitorNotificationProvider.MonitorNotificationProvider_SLACK:
      return new MonitorNotifierSlack();
    case EMonitorNotificationProvider.MonitorNotificationProvider_OPSGENIE:
      return new MonitorNotifierOpsgenie();
  }
  return undefined;
}

export function GetNotifierList(): Array<{
  class: IMonitorNotificationProviderBaseClass;
  provider: EMonitorNotificationProvider;
}> {
  return [
    // {class: new MonitorNotifierURL(), provider: EMonitorNotificationProvider.MonitorNotificationProvider_URL},
    {
      class: new MonitorNotifierEmail(),
      provider: EMonitorNotificationProvider.MonitorNotificationProvider_EMAIL,
    },
    {
      class: new MonitorNotifierSlack(),
      provider: EMonitorNotificationProvider.MonitorNotificationProvider_SLACK,
    },
    {
      class: new MonitorNotifierOpsgenie(),
      provider: EMonitorNotificationProvider.MonitorNotificationProvider_OPSGENIE,
    },
  ];
}
